import React, { useState } from 'react'
import { Box, Typography, Link } from '@material-ui/core'
import { useStyles } from './styles'
import { eventHighLights } from './constant'
import { VisibilityOutlined, VisibilityOffOutlined } from '@material-ui/icons'
import { eventService } from '../../Services'
import { connect } from 'react-redux'
import * as messageTypes from '../../utils/messageTypes'
import { DisplayMessage } from '../../Components'
import _ from 'lodash'
import CustomDialog from '../../Components/CustomDialog'
import SiteEventViewer from '../Reports/SitesDashboard/SiteEventViewer'

function EventHighlights(props) {
  const classes = useStyles()
  const highlights = eventHighLights(props.data, props.timeZone, props.isSuperAdmin, props.isViewOnly)
  const [showHighlights, setShowHighlights] = useState(true)
  const [eventsData, setEventsData] = useState(null)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('')
  const [showEventViewer, setShowEventViewer] = useState(false)
  const [dataLoading, setDataLoading] = useState(false)

  const getSiteEventData = (event_id) => {
    setDataLoading(true)
    eventService.getSiteEventData(event_id, props.currentUser.account_id)
      .then(data => {
        setEventsData(data)
        setDataLoading(false)
      })
      .catch(error => {
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to load Events Details'))
        setMessageType(messageTypes.ERROR)
        setOpen(true)
        setDataLoading(false)
      })
  }

  const handleOpenSiteViewer = () => {
    if (!eventsData && !dataLoading && props?.data?.event_id) {
      getSiteEventData(props.data.event_id)
    }
    setShowEventViewer(true)
  }

  const handleCloseSiteViewer = () => {
    setShowEventViewer(false)
  }

  return (
    <Box className={classes.contentWrapper}>
      <DisplayMessage
        open={open}
        message={message}
        messageType={messageType}
        handleClose={() => setOpen(false)}
      />
      <Box className={classes.contentTitle} display="flex" justifyContent="space-between">
        <Box>Event Highlights</Box>
        {showHighlights ? <VisibilityOffOutlined className={classes.eyeIcon} onClick={() => setShowHighlights(showHighlights => !showHighlights)} /> : <VisibilityOutlined className={classes.eyeIcon} onClick={() => setShowHighlights(showHighlights => !showHighlights)} />}
      </Box>
      {showHighlights &&
        <Box className={classes.highlightWrapper}>
          {highlights.filter(Boolean).map((obj, index) => {
            return (
              <Box key={obj.label || index} className={classes.highlightRow}>
                <Typography className={classes.highlightLabel}>{obj.label}</Typography>
                {obj.isLink
                  ? <Link
                    component="button"
                    variant="body2"
                    onClick={
                      obj.label === 'Total Systems'
                        ? props.handleSystemClick
                        : obj.label === 'Event Viewer'
                        ? handleOpenSiteViewer
                        : undefined
                    }
                    style={{ color: '#3B86FF' }}
                  >
                    {obj.value}
                  </Link>
                  : <Typography className={classes.highlightValue}>{obj.value}</Typography>}
              </Box>
            )
          })}
        </Box>
      }
      {showEventViewer && (
        <CustomDialog
          open={showEventViewer}
          handleClose={handleCloseSiteViewer}
          title="Event Information"
          content={
            <Box className={classes.eventViewerPopupContainer}>
              {dataLoading ? (
                <Typography>Loading...</Typography>
              ) : (
                <SiteEventViewer isPopup={true} initialData={eventsData} />
              )}
            </Box>
          }
          maxWidth="xl"
          fullWidth
        />
      )}
    </Box>
  )
}

EventHighlights.defaultProps = {
  handleSystemClick: () => { }
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin, isAdmin, isViewOnly } = auth
  return { currentUser, isSuperAdmin, isAdmin, isViewOnly }
}

export default connect(mapStateToProps)(EventHighlights)